import * as React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import * as C from '../../constants';
import { Card, Button } from './index';
import * as Common from '../common';

const ChooseButton = styled(Button)`
  width: 100%;
  margin-top: 1em;
`;

const SelectedChooseButton = styled(Button)`
  width: 100%;
  margin-top: 1em;
  background: ${C.COLORS.primaryColor};
  color: ${C.COLORS.darkYellowColor};

  &:active,
  :hover,
  :focus {
    background: ${C.COLORS.primaryColor};
    color: ${C.COLORS.darkYellowColor};
  }
`;

const SavingsInfo = styled(Button)`
  width: 100%;
  background: #fff000;
  border: none;
  margin-top: 1em;
  font-style: italic;

  &:active,
  :hover,
  :focus {
    background: ${C.COLORS.darkYellowColor};
  }
`;

const VisibilityHiddenH4 = styled(Common.H4)`
  visibility: hidden;
`;

const PlanDescription = styled.p`
  color: ${C.COLORS.textDarkColor};
`;

interface Props {
  title: string | React.ReactElement<any>;
  price: string | React.ReactElement<any>;
  description: string | React.ReactElement<any>;
  priceUnit: string | React.ReactElement<any>;
  buttonText: string | React.ReactElement<any>;
  selected: boolean;
  loading: boolean;
  onClick: React.EventHandler<any>;
  discount?: number;
}

// TODO: move out.
function formatDiscount(discount: number): string {
  return (discount * 100).toFixed(2);
}

export const PlanCard: React.SFC<Props> = props => (
  <Card loading={props.loading} bordered title={props.title}>
    <Common.SubH4>
      <FormattedMessage id="T1763.Subscription.cart.PriceTitle" />
    </Common.SubH4>
    <Common.H2>{props.price}</Common.H2>
    {props.priceUnit ? (
      <Common.H4>{props.priceUnit}</Common.H4>
    ) : (
      <VisibilityHiddenH4>Placeholder</VisibilityHiddenH4>
    )}

    {Boolean(props.description) && (
      <PlanDescription>{props.description}</PlanDescription>
    )}

    {Boolean(props.discount) && (
      <SavingsInfo type="dashed">
        {props.discount && (
          <FormattedMessage
            id="T1763.Subscription.cart.AnnualPaymentDiscount"
            values={{
              discount: formatDiscount(props.discount),
            }}
          />
        )}
      </SavingsInfo>
    )}

    {props.selected ? (
      <SelectedChooseButton icon="check" size="large" onClick={props.onClick}>
        {props.buttonText}
      </SelectedChooseButton>
    ) : (
      <ChooseButton type="primary" size="large" onClick={props.onClick}>
        {props.buttonText}
      </ChooseButton>
    )}
  </Card>
);



// WEBPACK FOOTER //
// ./app/components/antd/PlanCard.tsx